module.exports = __webpack_public_path__ + "static/braddock-cf0f138ac9cc07ce323ec0d3225d95c6.jpg";